import { permissionsRol as schoolsRol } from 'app/policies/roles/schoolsRol.access';
import { PATH_SCHOOL, PATH_SCHOOLS, PATH_SCHOOL_CREATE } from 'app/router/routesConfigSchools';

export function schools(path, user) {
  if (PATH_SCHOOL === path) {
    return schoolsRol(user).readDetail;
  }

  if (PATH_SCHOOLS === path) {
    return schoolsRol(user).readList;
  }

  if (PATH_SCHOOL_CREATE === path) {
    return schoolsRol(user).create;
  }

  return true;
}
